// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Fail-closed frontend feature gate. Pure so it can be unit-tested; the actual
// `import.meta.env` read happens at the call site in the provider.

export function isEliaAiEnabled(value: string | undefined): boolean {
  return value === 'true';
}
